export const createParams = (params: Record<string, string>): string => {
  if (!params || typeof params !== 'object' || Array.isArray(params)) {
    return '';
  }
  return Object.entries(params).filter(([key, value]) => { return key !== '__proto__' && key !== 'constructor' && typeof value === 'string'; }).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
};
